import { render, staticRenderFns } from "./PostalSeparateInputs.nl.vue?vue&type=template&id=0f800950"
import script from "./PostalSeparateInputs.nl.vue?vue&type=script&lang=js"
export * from "./PostalSeparateInputs.nl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports